import { GetPipelineStageProjectsInput } from '@/gql/graphql';

// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

const pipelineKeys = {
  all: ['pipelines'] as const,
  pipeline: (id: string) => [...pipelineKeys.all, id] as const,
  pipelineBatchPrefetch: (
    pipelineId: string,
    input?: GetPipelineStageProjectsInput
  ) => [...pipelineKeys.pipeline(pipelineId), 'batch-prefetch', input] as const,
  pipelineStage: (pipelineId: string, stageId: string) =>
    [...pipelineKeys.pipeline(pipelineId), 'stages', stageId] as const,
  pipelineStageProjects: (
    pipelineId: string,
    stageId: string,
    input?: GetPipelineStageProjectsInput
  ) => {
    const baseKey = [
      ...pipelineKeys.pipelineStage(pipelineId, stageId),
      'projects',
    ] as const;
    if (!input) return baseKey;
    return [...baseKey, { input }] as const;
  },
  pipelineStageTargetingAutomations: (pipelineId: string, stageId: string) =>
    [
      ...pipelineKeys.pipelineStage(pipelineId, stageId),
      'targetingAutomations',
    ] as const,
};

export default pipelineKeys;
